import React from 'react';

function SocialMediaIcons({ githubLink, mediumLink, linkedinLink, mailLink, resume }) {
  return (
    <div className="social-media-icons">
			
			<a href={'/images/caner_resume.pdf'}>
				<img
					src="/images/icons8-resume-50.png"
					alt="Resume"
					title="Resume"
					width="30"
					height="30"
					className="mx-2"
				/>
			</a>

      <a href={githubLink} target="_blank" rel="noopener noreferrer">
        <img
          src="/images/github-mark.png"
          alt="Github"
					title="Github"
          width="30"
          height="30"
          className="mx-2"
        />
      </a>

      <a href={mediumLink} target="_blank" rel="noopener noreferrer">
        <img
          src="/images/icons8-medium-50.png"
          alt="Medium"
					title="Medium"
          width="30"
          height="30"
          className="mx-2"
        />
      </a>

      <a href={linkedinLink} target="_blank" rel="noopener noreferrer">
        <img
          src="/images/icons8-linkedin-50.png"
          alt="LinkedIn"
					title="LinkedIn"
          width="30"
          height="30"
          className="mx-2"
        />
      </a>

      {mailLink && (
        <a href={`mailto:${mailLink}`}>
          <img
            src="/images/icons8-mail-50.png"
            alt="Email"
						title="Email"
            width="30"
            height="30"
            className="mx-2"
          />
        </a>
      )}
    </div>
  );
}

export default SocialMediaIcons;
